import React from 'react'
import { Link as ReactLink } from "react-router-dom"
import Slider from "react-slick"
import Skeleton from "@material-ui/lab/Skeleton"
import Box from "@material-ui/core/Box"

const SubCategoriesCarousel = ({
    subCategories,
    reqPageNumber,
    reqMainCategoryId,
    reqSubCategoryId,
    loading,
    isMobile
}) => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
            // {
            //     breakpoint: 1024,
            //     settings: {
            //         slidesToShow: 8,
            //     },
            // },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 3,
                    infinite: false,
                },
            },
        ],
    };

    const number = [1, 2, 3, 4, 5, 6];
    return (
        (isMobile) ? (
            <div style={{ width: '100%' }}>
                <Slider {...settings}>
                    {(loading) ? (
                        (number.map((i) => (
                            <div data-index={i} key={i}>
                                <Box width={{ md: '145px', sm: '130px', xs: '100px' }} height={{ md: '145px', sm: '130px', xs: '100px' }} >
                                    <Skeleton animation="wave" variant="circle" width="100%" height="100%" />
                                </Box>
                            </div>
                        )))
                    ) : (
                        (subCategories.map((Category, i) => (
                            <div key={i}>
                                <div className="productListTopCatItem" style={{ backgroundImage: "url(/images/cat-bg.png)" }}>
                                    <ReactLink to={`/products/page/1/${reqMainCategoryId}/${Category.id}`}>
                                        <div
                                            className={
                                                Number(Category.id) !== Number(reqSubCategoryId)
                                                    ? "centerDiv"
                                                    : "centerActivedDiv"
                                            }>
                                            <h2>{Category.title}</h2>
                                        </div>
                                    </ReactLink>
                                </div>
                            </div>
                        )))
                    )}
                </Slider>
            </div>
        ) : (
            <Slider {...settings}>
                {(loading) ? (
                    (number.map((i) => (
                        <div key={i}>
                            <Box width={{ md: '145px', sm: '130px', xs: '100px' }} height={{ md: '145px', sm: '130px', xs: '100px' }} >
                                <Skeleton animation="wave" variant="circle" width="100%" height="100%" />
                            </Box>
                        </div>
                    )))
                ) : (
                    (subCategories.map((Category, i) => (
                        <div key={i}>
                            <div className="productListTopCatItem" style={{ backgroundImage: "url(/images/cat-bg.png)" }}>
                                <ReactLink to={`/products/page/1/${reqMainCategoryId}/${Category.id}`}>
                                    <div
                                        className={
                                            Number(Category.id) !== Number(reqSubCategoryId)
                                                ? "centerDiv"
                                                : "centerActivedDiv"
                                        }>
                                        <h2>{Category.title}</h2>
                                    </div>
                                </ReactLink>
                            </div>
                        </div>
                    )))
                )}
            </Slider>
        )
    )
}
export default SubCategoriesCarousel

// export default class SubCategoriesCarousel extends React.Component {
//     constructor(props) {
//         super(props);
//     }
//     render() {
//         const settings = {
//             dots: false,
//             infinite: true,
//             slidesToShow: 3,
//             slidesToScroll: 1,
//             initialSlide: -1,
//             autoplay: false,
//             autoplaySpeed: 2000,
//             rtl: true
//         };
//         return (
//             <div>
//                 <h2>Right to Left</h2>

//             </div>
//         );
//     }
// }

// const settings = {
//     speed: 500,
//     rtl: true,
//     responsive: [
//         {
//             breakpoint: 1200,
//             settings: {
//                 slidesToShow: 6,
//                 slidesToScroll: 1,
//                 infinite: false,
//                 dots: false,
//             },
//         },
//         {
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 5,
//                 slidesToScroll: 1,
//                 initialSlide: 1,
//                 infinite: true,
//                 arrows: true
//             },
//         },
//         {
//             breakpoint: 880,
//             settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1,
//                 initialSlide: 1,
//                 arrows: false,
//                 infinite: true,
//                 dots: true,
//             },
//         },
//         {
//             breakpoint: 500,
//             settings: {
//                 slidesToShow: 3,
//                 dots: true,
//                 infinite: true,
//             },
//         },
//     ],
// };
// const SubCategoriesCarousel = ({
//     subCategories,
//     reqPageNumber,
//     reqMainCategoryId,
//     reqSubCategoryId,
//     loading,
// }) => {
//     const numbers2 = [1, 2, 3, 4, 5, 6];
//     return (
//         <>
//             <Slider {...settings}>

//                 {loading &&
//                     (numbers2.map((i) => (
//                         <div>
//                             <Box width={{ md: '145px', sm: '130px', xs: '100px' }} height={{ md: '145px', sm: '130px', xs: '100px' }} >
//                                 <Skeleton animation="wave" variant="circle" width="100%" height="100%" />
//                             </Box>
//                         </div>
//                     )))}
//                 {!loading && subCategories.map((Category, i) => (
//                     <div>
//                         <div className="productListTopCatItem" style={{ backgroundImage: "url(/images/cat-bg.png)" }}>
//                             <ReactLink to={`/products/page/${reqPageNumber}/${reqMainCategoryId}/${Category.id}`}>
//                                 <div
//                                     className={
//                                         Number(Category.id) !== Number(reqSubCategoryId)
//                                             ? "centerDiv"
//                                             : "centerActivedDiv"
//                                     }>
//                                     <h2>{Category.title}</h2>
//                                 </div>
//                             </ReactLink>
//                         </div>
//                     </div>
//                 ))}
//             </Slider>
//         </>
//     );
// };
// export default SubCategoriesCarousel;
